import { EventAdapter } from '~analytics/adapters/EventAdapter';
import { sendTeacherAmplitudeEvent } from '~analytics/amplitude';
import { EventTypes } from '~analytics/types';

export interface AiUsageLimitEventAdapterParams {
  limitType: 'per_day' | 'per_minute' | 'global_limit';
}

type AiUsageLimitEventData = {
  limit_type: 'per_day' | 'per_minute' | 'global_limit';
};

export class AiUsageLimitEventAdapter extends EventAdapter<AiUsageLimitEventData> {
  protected intercomEventKey = null;

  constructor({ limitType }: AiUsageLimitEventAdapterParams) {
    super();

    this.eventData = {
      limit_type: limitType,
    };
  }
  protected amplitudeEventFunction = function addQuizModalEvent(
    event: AiUsageLimitEventData
  ) {
    sendTeacherAmplitudeEvent(EventTypes.AiUsageLimit, event);
  };
}
